module.exports = __webpack_public_path__ + "img/earth_night_4096.758335c6.jpg";